import React from "react";

function MovingBg(){
    return(
        <div class="lines" className=" h-auto" >
      <div class="line"></div>
      <div class="line"></div>
      <div class="line"></div>
        <div class="line"></div>
    
    </div>
    )
}

export default MovingBg;